import { render, staticRenderFns } from "./cmpcentralnotificacao.vue?vue&type=template&id=91117346&"
import script from "./cmpcentralnotificacao.vue?vue&type=script&lang=js&"
export * from "./cmpcentralnotificacao.vue?vue&type=script&lang=js&"
import style0 from "./cmpcentralnotificacao.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports